<template>
  <div class="adword">
    <div class="adword__wrapper">
      <div class="adword__wrapper__header">
        <div class="adword__wrapper__header__title">
          <h1 class="medium-title">
            Campaign editor
          </h1>
        </div>
        <div class="adword__wrapper__header__subtitle">
          <span>
            Set your adwords campaign details
          </span>
        </div>
        <div class="adword__wrapper__header__breadcrumb">
          <adx-breadcrumb :items="breadcrumb" />
        </div>
      </div>
      <div class="adword__wrapper__content">
        <div v-if="step == 1" class="adword__wrapper__content__iklan">
          <div class="adword__wrapper__content__wrapper">
            <div class="adword__wrapper__content__wrapper__field">
              <adx-input :ref="dataRef1.name" :label="`Campaign Name *`" :error.sync="nameError" :validation="['NotEmpty', 'MaxLength:50']" :value.sync="name" />
            </div>
          </div>
          <div class="adword__wrapper__content__wrapper">
            <div class="adword__wrapper__content__wrapper__field">
              <adx-input :ref="dataRef1.url" :label="`Website URL *`" :error.sync="urlError" :validation="['NotEmpty', 'MaxLength:100', 'Url']" :value.sync="url" />
            </div>
          </div>
          <div class="adword__wrapper__content__wrapper">
            <div class="adword__wrapper__content__wrapper__header">
              <span class="title">Set Campaign Goal</span>
            </div>
            <div class="adword__wrapper__content__wrapper__fields__radio">
              <div class="radio-group">
                <div class="radio">
                  <input type="radio" id="one" value="wt" v-model="campaignGoal"/>
                  <label class="subhead" for="one">Web Traffic</label>
                </div>
                <p class="description">Get the right people to visit your website</p>
              </div>
              <div class="radio-group">
                <div class="radio">
                  <input type="radio" id="two" value="aw" v-model="campaignGoal"/>
                  <label class="subhead" for="two">Awareness</label>
                </div>
                <p class="description">Reach a broad audience and build awareness</p>
              </div>
            </div>
          </div>
          <div class="adword__wrapper__content__wrapper">
            <div class="adword__wrapper__content__wrapper__header">
              <span class="title">Company information</span>
            </div>
            <div class="adword__wrapper__content__wrapper__field">
              <adx-input :ref="dataRef1.companyName" :label="`Company Name *`" :error.sync="companyNameError" :validation="['NotEmpty', 'MaxLength:100']" :value.sync="companyName" />
            </div>
            <div class="adword__wrapper__content__wrapper__field">
              <adx-input :ref="dataRef1.companyPhone" :label="`Company Phone Number *`" :error.sync="companyPhoneError" :validation="['NotEmpty', 'Phone', 'MaxLength:16']" :value.sync="companyPhone" type="number"/>
            </div>
            <div class="adword__wrapper__content__wrapper__field">
              <adx-input :ref="dataRef1.companyAddress" :label="`Company Address *`" :error.sync="companyAddressError" :validation="['NotEmpty', 'MaxLength:200']" :value.sync="companyAddress" />
            </div>
            <div class="adword__wrapper__content__wrapper__fields">
              <adx-input :label="`City`" :value.sync="companyCity" />
              <adx-input :label="`Province`" :value.sync="companyProvince" />
            </div>
          </div>
        </div>
        <div v-else-if="step == 2" class="adword__wrapper__content__target">
          <div class="adword__wrapper__content__wrapper">
            <div class="adword__wrapper__content__wrapper__header">
              <span class="title">Select Location to Target</span>
            </div>
            <div class="adword__wrapper__content__wrapper__field">
              <adx-radio :grup="`locationGroup`" :options="locationOptions" :formStyle="`block`" :value.sync="location" />
            </div>
            <div v-if="!isIndonesia" class="adword__wrapper__content__wrapper__field">
              <adx-input :ref="dataRef2.location_detail" :label="`Type location here`" :value.sync="locationDetail" />
            </div>
          </div>
          <div class="adword__wrapper__content__wrapper">
            <div class="adword__wrapper__content__wrapper__header">
              <span class="title">Schedules</span>
            </div>
            <div class="adword__wrapper__content__wrapper__fields">
              <div class="schedule">
                <adx-dropdown :label="`Period of Campaign`" :options="periodOptions" class="dropdown" :value.sync="period"/>
              </div>
              <div class="calendar">
                <v-date-picker
                  v-model='startDate'
                  :min-date='nextweek'
                  :popoverVisibility="'focus'"
                  :theme-styles='themeStyles'
                  class='date-picker'>
                  <div class="field"
                    slot-scope='{ inputValue, updateValue }'
                  >
                    <input
                      class="date-picker-input"
                      type='text'
                      required
                      :value='inputValue'
                      @input='updateValue($event.target.value, { formatInput: false, hidePopover: false })'
                      @change='updateValue($event.target.value, { formatInput: true, hidePopover: false })'>
                      <label class="subhead calendar-label">Start Date</label>
                  </div>
                </v-date-picker>
              </div>
            </div>
          </div>
          <div class="adword__wrapper__content__wrapper">
            <div class="adword__wrapper__content__wrapper__header">
              <span class="title">Target Audience</span>
            </div>
            <div class="adword__wrapper__content__wrapper__field">
              <adx-dropdown :label="`Gender`" :options="audienceGenderOptions" class="dropdown" :value.sync="audienceGender"/>
            </div>
            <div class="adword__wrapper__content__wrapper__fields">
              <adx-dropdown :label="`Age`" :ref="dataRef2.audienceAgeFrom" :error.sync="audienceAgeFromError" :value.sync="audienceAgeFrom" class="dropdown" :options="ageOptions" @click.stop="ageValidation" />
              <div class="label">
                <label>to</label>
              </div>
              <adx-dropdown :label="`Age`" :ref="dataRef2.audienceAgeTo" :error.sync="audienceAgeToError" :value.sync="audienceAgeTo" class="dropdown" :options="ageOptions" @click.stop="ageValidation" />
            </div>
          </div>
          <div class="adword__wrapper__content__wrapper">
            <div class="adword__wrapper__content__wrapper__header">
              <span class="title">Keyword</span>
            </div>
            <div class="adword__wrapper__content__wrapper__field">
              <adx-radio :grup="`keywordGroup`" :options="keywordOptions" :formStyle="`block`" :value.sync="keywordOption" />
            </div>
            <div class="adword__wrapper__content__wrapper__field">
              <!-- <adx-textarea v-if="isManualSet" :label="`Description (max 90 characters)`" :value.sync="keywords"/> -->
              <adx-input-tag
                v-if="isManualSet"
                :limit='limit'
                v-model='keywords'
                :ref="dataRef2.keywords"
                :error.sync="keywordsError"
                :placeholder='placeholder'
                :read-only='readOnly'
                :validate='validate'
                :add-tag-on-blur='addTagOnBlur'
              />
            </div>
          </div>
        </div>
        <div v-if="step == 3" class="adword__wrapper__content__budget">
          <div class="adword__wrapper__content__wrapper">
            <div class="adword__wrapper__content__wrapper__header">
              <span class="title">Set Your Campaign Budget</span>
            </div>
            <div class="adword__wrapper__content__wrapper__field">
              <adx-dropdown :value.sync="budget" :type="true" :options="budgetOptions" />
            </div>
          </div>
          <div class="adword__wrapper__content__wrapper">
            <div class="adword__wrapper__content__wrapper__header">
              <span class="strong subhead">Promo Code</span>
            </div>
            <div v-if="!isPromoCodeValid" class="adword__wrapper__content__wrapper__fields">
              <adx-input :button="`Use`" :label="`Input Promo Code`" :error.sync="promoCodeError" :value.sync="promoCode" @buttonClicked="useVoucher" :upperCase="true"/>
            </div>
            <div v-else class="adword__wrapper__content__wrapper__fields">
              <div if class="adword__wrapper__content__wrapper__fields__dialog">
                <div class="adword__wrapper__content__wrapper__fields__dialog__button">
                  <i class="adx-ic_close" @click="unuseVoucher"></i>
                </div>
                <div class="adword__wrapper__content__wrapper__fields__dialog__header">
                  <span>Kode Promo: </span>
                  <span class="code">{{promoCode}}</span>
                </div>
                <div class="adword__wrapper__content__wrapper__fields__dialog__description">
                  <span>
                    Congrats! you get discount - {{discount | formatMoney}} for this transaction
                  </span>
                </div>
              </div>
              <span v-if="promoCodeError" class="adword__wrapper__content__wrapper__error"> {{promoCodeError}} </span>
            </div>
            <div class="payment__clear-both"></div>
          </div> 
          <div v-if="promoNominal" class="adword__wrapper__content__wrapper">
            <div class="adword__wrapper__content__wrapper__header">
              <span class="strong subhead">Total Price : {{ discountedPrice | formatMoney }}</span>
            </div>
            <p>*This is price you need to pay after discount</p>
          </div>
          <div class="adword__wrapper__content__wrapper">
            <div class="adword__wrapper__content__wrapper__header">
              <span class="title">Ad Description</span>
            </div>
            <div class="adword__wrapper__content__wrapper__field">
              <adx-input :ref="dataRef3.headline" :error.sync="headlineError" :label="`Headline (max 30 characters) *`" :validation="['NotEmpty', 'MaxLength: 30']" :value.sync="headline" />
            </div>
            <div class="adword__wrapper__content__wrapper__field">
              <adx-textarea :ref="dataRef3.adDescription" :error.sync="adDescriptionError" :label="`Description (max 90 characters) *`" :validation="['NotEmpty', 'MaxLength: 90']" :value.sync="adDescription"/>
            </div>
          </div>
          <div class="adword__wrapper__content__wrapper">
            <div class="adword__wrapper__content__wrapper__header">
              <span class="title">Ad Preview</span>
            </div>
            <div class="adword__wrapper__content__wrapper__field">
              <div class="ad-wrapper">
                <label class="ad-wrapper__header">{{headline}}</label><br />
                <label class="ad-wrapper__url">{{url}}</label><br />
                <label class="ad-wrapper__description">{{adDescription}}</label><br />
              </div>
            </div>
          </div>
          <div class="adword__wrapper__content__wrapper">
            <div class="adword__wrapper__content__wrapper__header">
              <span class="title">Additional Notes and Comments</span>
            </div>
            <div class="adword__wrapper__content__wrapper__field">
              <adx-textarea :label="`Your message max 200 characters`" :value.sync="notes" :validation="['MaxLength:200']"/>
            </div>
          </div>
        </div>
      </div>
      <div class="adword__wrapper__button">
        <button
          v-if="step > 1"
          type="button"
          class="btn-large secondary"
          :disabled="isSaving"
          @click="previous">
          Previous
        </button>
        <button
          v-if="step < 3"
          type="button"
          class="btn-large primary"
          :disabled="isSaving"
          @click="next">
          Continue
        </button>
        <button
          v-if="step == 3"
          type="button"
          class="btn-large primary"
          @click="sendEmail"
          :disabled="isSaving">
          Submit
          <adx-loading-secondary v-if="isSaving" slot="loading" class="loading" />
        </button>
      </div>
    </div>
  </div>
</template>

<script>
import Breadcrumb from '@/components/Breadcrumb'
import Input from '@/components/Form/Input'
import InputTag from '@/components/Form/InputTag'
import Radio from '@/components/Form/Radio'
import TextArea from '@/components/Form/TextArea'
import Dropdown from '@/components/Form/SelectDropdown'
import LoadingSpinner from '@/components/Loading/Secondary-white'
import moment from 'moment';

import api from '@/api'
import { apiV2 } from '@/api/urls'

export default {
  name: 'adx-adword',
  components: {
    'adx-breadcrumb': Breadcrumb,
    'adx-input': Input,
    'adx-radio': Radio,
    'adx-textarea': TextArea,
    'adx-dropdown': Dropdown,
    'adx-loading-secondary': LoadingSpinner,
    'adx-input-tag': InputTag
  },
  props: {

  },
  data() {
    return {
      readOnly: false,
      addTagOnBlur: false,
      allowDuplicates: false,
      placeholder: "Separate keywords with a comma",
      tags: [],
      limit: 100,
      validate: "",
      step: 1,
      today: moment(),
      dataRef1: {
        name: 'name',
        url: 'url',
        companyName: 'companyName',
        companyPhone: 'companyPhone',
        companyAddress: 'companyAddress'
      },
      dataRef2: {
        audienceAgeFrom: 'audienceAgeFrom',
        audienceAgeTo: 'audienceAgeTo',
        keywords: 'keywords'
      },
      dataRef3: {
        headline: 'headline',
        adDescription: 'adDescription'
      },
      name: '',
      nameError: '',
      url: '',
      urlError: '',
      campaignGoal: '',
      companyName: '',
      companyNameError: '',
      companyPhone: '',
      companyPhoneError: '',
      companyAddress: '',
      companyAddressError: '',
      companyCity: '',
      companyProvince: '',
      location: '',
      locationDetail: '',
      period: '',
      startDate: '',
      audienceGender: '',
      audienceAgeFrom: '',
      audienceAgeFromError: '',
      audienceAgeTo: '',
      audienceAgeToError: '',
      keywordOption: '',
      keywords: [],
      keywordsError: '',
      budget: null,
      headline: '',
      headlineError: '',
      adDescription: '',
      adDescriptionError: '',
      notes: '',
      isIndonesia: true,
      isManualSet: false,
      isSaving: false,
      promoCode: '',
      discount: 0,
      promoNominal: 0,
      isPromoCodeValid: false,
      promoCodeError: '',
      locationOptions: [
        {
          label: 'Indonesia',
          value: 'idn',
        },
        {
          label: 'Specific Location',
          value: 'etc',
        }
      ],
      keywordOptions: [
        {
          label: 'Let us give best keyword for you',
          value: '0',
        },
        {
          label: 'Create keyword manually',
          value: '1',
        }
      ],
      periodOptions: [
        {
          id: 0,
          label: `1 week`,
          value: `1 week`
        },
        {
          id: 1,
          label: `2 week`,
          value: `2 week`
        },
        {
          id: 2,
          label: `1 month`,
          value: `1 month`
        },
        {
          id: 3,
          label: `2 month`,
          value: `2 month`
        },
        {
          id: 4,
          label: `3 month`,
          value: `3 month`
        },
      ],
      budgetOptions: [
        {
          id: 0,
          label: `250.000`,
          value: `250000`
        },
        {
          id: 1,
          label: `500.000`,
          value: `500000`
        },
        {
          id: 2,
          label: `1.000.000`,
          value: `1000000`
        },
        {
          id: 3,
          label: `5.000.000`,
          value: `5000000`
        },
        {
          id: 4,
          label: `10.000.000`,
          value: `10000000`
        },
        {
          id: 5,
          label: `15.000.000`,
          value: `15000000`
        },
        {
          id: 6,
          label: `20.000.000`,
          value: `20000000`
        },
        {
          id: 7,
          label: `25.000.000`,
          value: `25000000`
        },
        {
          id: 8,
          label: `30.000.000`,
          value: `30000000`
        }
      ],
      audienceGenderOptions: [
        {
          id: 0,
          label: `All Gender`,
          value: '1'
        },
        {
          id: 1,
          label: `Male`,
          value: '2'
        },
        {
          id: 2,
          label: `Female`,
          value: '3'
        }
      ],
      ageOptions: [],
      breadcrumb: [
        {
          title: '1. Iklan',
          isCurrent: true
        },
        {
          title: '2. Target',
          isCurrent: false
        },
        {
          title: '3. Budget',
          isCurrent: false
        }
      ],
      themeStyles: {
        dayContent: {
          fontSize: '15px',
        },
        headerTitle: {
          fontSize: '17px',
          fontWeight: 'bold'
        },
        weeks: {
          fontWeight: 'bold'
        },
        wrapper: {
          boxShadow: '0 1px 4px 0 rgba(0, 0, 0, 0.16)',
          backgroundColor: 'white',
          border: 'none',
        },
        header: {
          marginBottom: '6px'
        },
        dayCellNotInMonth: {
          opacity: 0,
        }
      }
    }
  },
  computed: {
    nextweek() {
      var nextweek = new Date();
      nextweek.setDate(nextweek.getDate() + 7);
      return nextweek
    },
    discountedPrice() {
      var price = this.budget - this.promoNominal
      if (price < 0) return 0
      return price
    }
  },
  watch: {
    audienceAgeFrom: function () {
      this.$nextTick(() => {
        this.ageValidation()
      });
    },
    audienceAgeTo: function () {
      this.$nextTick(() => {
        this.ageValidation()
      });
    },
    location: function () {
      this.$nextTick(() => {
        this.locationValidation()
      });
    },
    keywordOption: function () {
      this.$nextTick(() => {
        this.keywordChange()
      });
    },
    keywords: function () {
      this.$nextTick(() => {
        this.keywordValidation()
      });
    },
    promoCode: function () {
      this.promoCode = this.promoCode.toUpperCase()
    },
  },
  beforeCreate() {

  },
  created() {

  },
  beforeMount() {
    this.setValue()
  },
  mounted() {

  },
  beforeUpdate() {

  },
  updated() {

  },
  activated() {

  },
  deactivated() {

  },
  beforeDestroy() {

  },
  destroyed() {

  },
  methods: {
    useVoucher() {
      (async () => {
        this.promoCodeError = ''
        this.discount -= this.promoNominal
        let params = {
          voucher_code: this.promoCode
        }
        const response = await api.get(apiV2.checkVoucher, { needToken: true, params: params })
        if (response.status == 200) {
          this.promoNominal = response.data.nominal
          this.discount += response.data.nominal
          // if (parseInt(this.budget) <= this.promoNominal) {
          //   this.promoNominal = parseInt(this.budget)
          //   this.discount = parseInt(this.budget)
          // } 
          // else if (this.totalPrice < 9999 ) {
          //   this.promoCodeError = 'Total price should not be be between Rp 0 and Rp 10.000'
          //   this.loadingMidTrans = true
          // } 
          this.isPromoCodeValid = true
        } else {
          this.isPromoCodeValid = false
          this.promoCodeError = response.data.message
        }
      })();
    },
    unuseVoucher() {
      this.isPromoCodeValid = false
      this.discount -= this.promoNominal
      this.promoNominal = 0
    },
    setValue() {
      var nextweek = new Date();
      nextweek.setDate(nextweek.getDate() + 7);
      this.setAge()
      this.campaignGoal = "wt"
      this.period = this.periodOptions[0].value
      this.audienceGender = this.audienceGenderOptions[0].value
      this.location = this.locationOptions[0].value
      this.keywordOption = this.keywordOptions[0].value
      this.startDate = nextweek
      this.audienceAgeFrom = 16
      this.audienceAgeTo = 35
      this.budget = this.budgetOptions[0].value
      this.breadcrumb[this.step-1].isCurrent = false
      this.breadcrumb[0].isCurrent = true
      this.step = 1
    },
    setAge() {
      var arr = new Array();
      var j = 0;
      for (var i = 16; i < 65; i++) {
        var age = {
          id: j,
          label: i,
          value: i
        };
        arr.push(age)
        j++;
      }
      this.ageOptions = arr
    },
    previous() {
      this.breadcrumb[this.step-1].isCurrent = false
      this.breadcrumb[this.step-2].isCurrent = true
      this.step = this.step == 2 ? 1 : 2
    },
    next() {
      let validation = this.validateForm()
      if (validation.isValid) {
        this.breadcrumb[this.step-1].isCurrent = false
        this.breadcrumb[this.step].isCurrent = true
        this.step = this.step == 1 ? 2 : 3
      } else {
        this.raiseError(validation.id)
      }
    },
    sendEmail() {
      (async () => {
        this.isSaving = true
        let validation = this.validateForm()
        let keyword = this.keywordOption == this.keywordOptions[0].value ? this.keywordOptions[0].label : this.keywords.join()
        let location = this.location == this.locationOptions[0].value ? this.locationOptions[0].label : this.locationDetail
        if (validation.isValid) {
          const body = {
            adword: {
              campaign_name: this.name,
              keyword: keyword,
              notes: this.notes
            },
            company: {
              name: this.companyName,
              mobile: this.companyPhone,
              address: this.companyAddress,
              city: this.companyCity,
              province: this.companyProvince
            },
            detail_ads: {
              url: this.url,
              campaign_goal: this.campaignGoal,
              location: location,
              period: this.period,
              start_date: this.startDate,
              audience_gender: this.audienceGender,
              audience_age_from: this.audienceAgeFrom,
              audience_age_to: this.audienceAgeTo,
              budget: this.budget,
              headline: this.headline,
              description: this.adDescription
            },
            promo: {
              code: this.promoCode,
              nominal: this.promoNominal
            }
          }
          const response = await api.post(apiV2.adWord, body, {needToken: true})
          if (response.status === 201) {
            this.$notify({
              group: 'saved',
              title: 'Success',
              text: `Data successfully saved!`,
              type: 'success'
            });
            this.$router.push({name: 'transactiondigitaladvertising'})
          } else {
            this.$notify({
              group: 'saved',
              title: 'Error',
              text: response.statusText,
              type: 'danger'
            });
          }
        } else {
          this.raiseError(validation.id)
        }
        this.isSaving = false
      })();
    },
    ageValidation() {
      if (this.audienceAgeFrom && this.audienceAgeTo) {
        if (this.audienceAgeFrom > this.audienceAgeTo) {
          this.audienceAgeFromError = "Age is not valid."
          this.audienceAgeToError = "Age is not valid."
        } else {
          this.audienceAgeFromError = ""
          this.audienceAgeToError = ""
        }
      }
    },
    locationValidation() {
      if (this.location == "idn") {
        this.isIndonesia = true
      } else {
        this.isIndonesia = false
      }
    },
    keywordChange() {
      if (this.keywordOption == 0) {
        this.isManualSet = false
      } else {
        this.isManualSet = true
      }
    },
    keywordValidation() {
      if (this.keywordOption == 0) {
        this.keywordsError = ""
      } else {
        if (this.keywords.length == 0) {
          this.keywordsError = "You can’t leave this empty"
        } else {
          this.keywordsError = ""
        }
      }
    },
    validateForm() {
      let data = { isValid: true, id: null }
      let dataRef = null
      if (this.step == 1) {
        dataRef = this.dataRef1
      } else if (this.step == 2) {
        dataRef = this.dataRef2
      } else if (this.step == 3) {
        dataRef = this.dataRef3
      }

      for (let key in dataRef) {
        const value = this.$data[key]
        if (!value || this.inputInvalid(dataRef[key])) {
          data.isValid = false
          // data.id = dataRef[key]
          if (this.step == 1) {
            data.id = this.dataRef1[key]
          } else if (this.step == 2) {
            data.id = this.dataRef2[key]
          } else if (this.step == 3) {
            data.id = this.dataRef3[key]
          }
          break
        }
      }

      return data
    },
    raiseError(id) {
      let element = this.$refs[id].$el.firstElementChild
      element.focus()
      element.blur()
    },
    inputInvalid(value) {
      let error = false
      let dataRef = null
      if (this.step == 1) {
        dataRef = this.dataRef1
      } else if (this.step == 2) {
        dataRef = this.dataRef2
      } else if (this.step == 3) {
        dataRef = this.dataRef3
      }
      switch(value) {
        case dataRef.name:
          error = this.nameError
          break
        case dataRef.url:
          error = this.urlError
          break
        case dataRef.companyName:
          error = this.companyNameError
          break
        case dataRef.companyPhone:
          error = this.companyPhoneError
          break
        case dataRef.companyAddress:
          error = this.companyAddressError
          break
        case dataRef.audienceAgeFrom:
          error = this.audienceAgeFromError
          break
        case dataRef.audienceAgeTo:
          error = this.audienceAgeToError
          break
        case dataRef.keywords:
          this.keywordValidation()
          error = this.keywordsError
          break
      }
      return error
    },
    reset() {
      this.url = ''
      this.campaignGoal = ''
      this.companyName = ''
      this.companyPhone = ''
      this.companyAddress = ''
      this.companyCity = ''
      this.companyProvince = ''
      this.location = ''
      this.locationDetail = ''
      this.period = ''
      this.startDate = ''
      this.audienceGender = ''
      this.audienceAgeFrom = ''
      this.audienceAgeTo = ''
      this.keywordOption = ''
      this.keywords = []
      this.budget= null
      this.headline = ''
      this.adDescription = ''
      this.setValue()
    }
  }
}
</script>

<style lang='scss' scoped>
@import './index.scss';
</style>
<style lang='scss'>
  .selectDropdown {

    .select {
      .standardInput {
        padding: 16px !important;
      }
    }

    .popup {
      max-height: 300px;
      overflow-y: auto !important;
    }
  }
  .small-title {
    font-size: 15px;
    font-weight: normal !important;

    &.current {
      font-weight: bold !important;
    }
  }
</style>
